<template>
  <div class="content">
    <PageHeader :title="$tc('generic-str.menu.providers', 2)">
      <template v-slot:actions>
        <li>
          <ButtonComponent variant="primary">
            <router-link :to="'/admin/providers/create'">
              <span class="material-symbols-outlined">
                add
              </span>
            </router-link>
          </ButtonComponent>
        </li>
      </template>
    </PageHeader>
    <section class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
          <CardComponent variant="tertiary">
            <TableComponent :fields="fields" :items="providers" :busy="!fetched">
              <template #cell(channel)="slotProps">
                <span v-if="slotProps.item.sms" class="col">
                  <i class="fas fa-sms fa-fw"></i>
                </span>
                <span v-if="slotProps.item.email" class="col">
                  <i class="fas fa-envelope-open fa-fw"></i>
                </span>
                <span v-if="slotProps.item.whatsapp" class="col">
                  <i class="fab fa-whatsapp fa-fw"></i>
                </span>
                <span v-if="slotProps.item.rcs" class="col">
                  <i class="fab fa-google fa-fw"></i>
                </span>
              </template>
              <template #cell(values)="slotProps">
                <BadgeComponent v-for="(cost, carrier) in slotProps.data.sms" :key="carrier" variant="light" class="ml-1 mt-1">
                  {{ carrier === 'other' ? $tc('app.other', 2) : carrier }}: {{ cost }}
                </BadgeComponent>
              </template>
              <template #cell()="slotProps">
                <DropdownComponent no-caret variant="link">
                  <template #button>
                    <span class="material-symbols-outlined">more_horiz</span>
                  </template>
                  <router-link :to="`/admin/providers/${slotProps.item.id}`" class="dropdown-item">
                    {{ $tc('app.edit') }}
                  </router-link>
                  <a class="dropdown-item" href="javascript:void(0)" @click="remove(slotProps.item.id)">{{
                    $tc('app.delete') }}</a>
                </DropdownComponent>
              </template>
            </TableComponent>
          </CardComponent>
        </div>
      </div>
    </section>
    <edit-provider-modal id="edit-provider-modal" @sent="fetch"></edit-provider-modal>
    <create-provider-modal id="create-provider-modal" @sent="fetch"></create-provider-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeader from '@/components/PageHeader.vue';
import ProviderService from '@/services/admin/provider.service';
import CreateProviderModal from '@/components/providers/CreateProviderModal.vue';
import EditProviderModal from '@/components/providers/EditProviderModal.vue';
import Swal from 'sweetalert2';
import CardComponent from '@/components/CardComponent.vue';
import TableComponent from '@/components/TableComponent.vue';
import BadgeComponent from '@/components/ui/BadgeComponent.vue';
import DropdownComponent from '@/components/DropdownComponent.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';

export default {
  name: 'Providers',
  components: {
    PageHeader,
    EditProviderModal,
    CreateProviderModal,
    CardComponent,
    TableComponent,
    DropdownComponent,
    ButtonComponent,
    BadgeComponent,
  },
  data() {
    return {
      fetched: false,
      fields: [
        'name',
        'channel',
        { key: 'values', label: this.$tc('app.cost', 2) },
        '',
      ],
      providers: [],
      form: {
        name: '',
        page: 1,
      },
      pages: 1,
      updating: false,
    };
  },
  created() {
    this.fetch(1);
  },
  methods: {
    fetch(page = 1) {
      this.form.page = page;
      this.fetched = false;
      ProviderService.getProviders(this.form).then(
        (response) => {
          this.fetched = true;
          this.providers = response.data;
          this.pages = response.last_page;
        },
        (error) => {
          this.content = error;
        },
      );
    },
    remove(id) {
      Swal.fire({
        title: this.$t('generic-str.r-sure'),
        text: this.$t('adm-component.delet-text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('warnings.btn-y-delete'),
      }).then((result) => {
        if (result.isConfirmed) {
          this.fetched = false;
          ProviderService.deleteProvider(id).then(
            () => {
              this.fetch(this.form.page);
              Swal.fire(`${this.$t('generic-str.deleted')}!`, this.$t('adm-component.delet-done'), 'success');
            },
            (error) => {
              this.content = error;
            },
          );
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.btn-remove {
  color: #fff;
  margin-bottom: 5px;
}

.btn-new {
  margin-bottom: 5px;
}

.color-white {
  color: #fff;
}

.form-search {
  float: right;
  width: 100%;
}

.form-search button {
  border: solid 1px #ccc;
  border-left: 0px;
  text-align: center;
  border-radius: 0px 10px 10px 0px;
  height: 35px;
}

.form-search button i {
  font-size: 16px;
}

.w-100 {
  width: 100% !important;
}
</style>
